var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-input", class: _vm.wrapperClass }, [
    _c("input", {
      class: { error: _vm.hasError },
      attrs: {
        type: _vm.computedType,
        name: _vm.name,
        placeholder: " ",
        "data-qa": _vm.dataQa,
        autocomplete: _vm.autocomplete,
      },
      domProps: { value: _vm.value },
      on: {
        input: _vm.noSpaceInput,
        blur: function ($event) {
          return _vm.$emit("blur")
        },
      },
    }),
    _c("label", [_vm._v(_vm._s(_vm.label))]),
    _vm.type === "password"
      ? _c(
          "button",
          {
            staticClass: "custom-btn btn-eye",
            attrs: { type: "button" },
            on: { click: _vm.togglePassword },
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.showPassword ? "visibility_off" : "visibility") +
                  "\n    "
              ),
            ]),
          ]
        )
      : _vm._e(),
    _vm.type === "password" && _vm.hasError
      ? _c("span", { staticClass: "help is-danger" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }